export const EXSBOWNER_SHOW_RESET = 'EXSBOWNER_SHOW_RESET'
export const EXSBOWNER_SHOW_SET_ERROR = 'EXSBOWNER_SHOW_SET_ERROR'
export const EXSBOWNER_SHOW_SET_RETRIEVED = 'EXSBOWNER_SHOW_SET_RETRIEVED'
export const EXSBOWNER_SHOW_TOGGLE_LOADING = 'EXSBOWNER_SHOW_TOGGLE_LOADING'
